import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "aiGenContainer"
};
const _hoisted_2 = {
  class: "aiGenHeader"
};
const _hoisted_3 = {
  class: "aiGenTitlePopin"
};
const _hoisted_4 = {
  class: "aiGenPlayer"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  class: "buttonBar"
};
const _hoisted_7 = {
  class: "stepper txtEditing"
};
const _hoisted_8 = {
  class: "buttonBarTxtEdition"
};
const _hoisted_9 = {
  class: "comboBoxLang"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_icon = _resolveComponent("icon");
  const _component_w_input = _resolveComponent("w-input");
  const _component_w_select = _resolveComponent("w-select");
  const _component_light_button = _resolveComponent("light-button");
  const _component_standard_button = _resolveComponent("standard-button");
  const _component_loader = _resolveComponent("loader");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('voiceOver.txt.title')), 1), _createVNode(_component_icon, {
    icon: "close",
    size: "medium",
    class: "aiGenCloseButton",
    onClick: _ctx.onClose
  }, null, 8, ["onClick"])]), _createElementVNode("div", _hoisted_4, [_createElementVNode("audio", {
    ref: "audioPlayer",
    src: _ctx.urlBlob
  }, null, 8, _hoisted_5)]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createVNode(_component_w_input, {
    type: "textarea",
    class: "textArea",
    placeholder: _ctx.$t('voiceOver.txt.type'),
    modelValue: _ctx.textToGenerate,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.textToGenerate = $event),
    "show-word-limit": true,
    maxlength: 3000,
    resize: "none"
  }, null, 8, ["placeholder", "modelValue"]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createVNode(_component_w_select, {
    placeholder: _ctx.$t('voiceOver.txt.voiceSelectPlaceholdler'),
    options: _ctx.listOfLang,
    value: _ctx.listOfLang[0],
    modelValue: _ctx.langTxtSelected,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.langTxtSelected = $event)
  }, null, 8, ["placeholder", "options", "value", "modelValue"])]), _cache[2] || (_cache[2] = _createElementVNode("div", {
    class: "spacer"
  }, null, -1)), !_ctx.loadingVoiceFromText ? (_openBlock(), _createBlock(_component_light_button, {
    key: 0,
    class: "buttonCancelTxtEdition",
    onAction: _ctx.cancelTxtVoiceAI
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('voiceOver.txt.button.cancel')), 1)]),
    _: 1
  }, 8, ["onAction"])) : _createCommentVNode("", true), !_ctx.loadingVoiceFromText ? (_openBlock(), _createBlock(_component_standard_button, {
    key: 1,
    onAction: _ctx.previewVoiceAI,
    outlined: true,
    disabled: !_ctx.langTxtSelected || !_ctx.textToGenerate
  }, {
    default: _withCtx(() => [_createVNode(_component_icon, {
      icon: "play"
    }), _createTextVNode(" " + _toDisplayString(_ctx.$t('voiceOver.txt.button.preview')), 1)]),
    _: 1
  }, 8, ["onAction", "disabled"])) : _createCommentVNode("", true), !_ctx.loadingVoiceFromText ? (_openBlock(), _createBlock(_component_standard_button, {
    key: 2,
    onAction: _ctx.confirmTxtVoiceAI,
    class: "confirmButton",
    disabled: !_ctx.urlBlob || _ctx.waitingTranscoding,
    loading: _ctx.waitingTranscoding
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('voiceOver.txt.button.confirm')), 1)]),
    _: 1
  }, 8, ["onAction", "disabled", "loading"])) : (_openBlock(), _createBlock(_component_standard_button, {
    key: 3,
    disabled: true
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('voiceOver.txt.waiting')), 1), _createVNode(_component_loader, {
      "spinner-size": 'spinnersSmall',
      class: "loader",
      "spinner-color": 'lightSpinner'
    })]),
    _: 1
  }))])])])]);
}